'use strict';

wbApp.filter('ageRangeFlt', function () {
    return function (input, courseAgeRangeID) {
        if (!courseAgeRangeID) {
            return input;
        }

        var out = [];
        for (var i = 0; i < input.length; i++) {
            var entity = input[i];
            if (entity.courseAgeRangeID == courseAgeRangeID) {
                out.push(entity);
            }
        }
        return out;
    }
});